export default __webpack_public_path__ + "static/media/Iron Butterfly.026ca5ba.svg";